import StringMask from 'string-mask'

angular.module("eficienciaFiscalModule").filter("efMask", () => {
    return (input_value, mask) => {
        return StringMask.apply(input_value, mask)
    }
})
